module.exports = __webpack_public_path__ + "img/resized-APP-0025-2.84db01ca.png";